import { Component, Input } from '@angular/core';

@Component({
  selector: 'trpx-dubai-card',
  templateUrl: './dubai-card.component.html',
  styleUrls: ['./dubai-card.component.scss']
})
export class DubaiCardComponent {
 @Input() disneyCards: any;
@Input() isOrange: boolean = false;

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          variableWidth: false,
        },
      },
    ],
  };

}
